
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/hackathon2022",
      function () {
        return require("private-next-pages/events/hackathon2022/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/hackathon2022"])
      });
    }
  